import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "react-axios";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { getRecentPlaylists } from "~/api/getCustomPlaylists";
import PlaylistCard from "./PlaylistCard";

const PlaylistRecentGrid = ({ limit = 12 }) => {
  const [loading, setLoading] = useState(true);
  const [playlists, setPlaylists] = useState([]);
  const load = async () => {
    const resp = await getRecentPlaylists(axios, limit);
    setPlaylists(resp.data.playlists);
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, []);
  return (
    <>
      {!loading && playlists.length > 0 ? (
        <>
          {playlists.map((p) => (
            <Col xs={12} sm={12} md={6} lg={limit < 12 ? 4 : 3} style={{ marginBottom: 40 }}>
              <PlaylistCard p={p} />
            </Col>
          ))}
        </>
      ) : loading ? (
        <Col xs={12}>
          <div>Loading...</div>
        </Col>
      ) : (
        <Col xs={12}>
          <div>
            <p>No Playlists yet</p>
          </div>
        </Col>
      )}
    </>
  );
};

export default PlaylistRecentGrid;
